import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * GroupHeader — заголовок-секция группы (`.grp`/`.grp-h` макета). Общий под-элемент,
 * переиспользуемый в DataTable, TrafficRow и списках выбора.
 *
 * Это ВИЗУАЛЬНЫЙ заголовок-метка, а не контейнер строк, поэтому ARIA-роль не навязывается
 * (`role="rowgroup"` валиден только внутри table/grid и здесь был бы ошибкой). Программная связь
 * с группой строк устанавливается consumer-ом: задайте `id` заголовку и `aria-labelledby={id}`
 * на контейнере соответствующей группы.
 */
export const GROUP_HEADER_CLASS =
  'bg-group px-4 py-2.5 text-11 font-semibold uppercase tracking-wider text-txt-secondary'

export const GroupHeader = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn(GROUP_HEADER_CLASS, 'border-b border-line', className)} {...props} />
  ),
)
GroupHeader.displayName = 'GroupHeader'
